import BookingConversion from '@components/charts/membership/event/BookingConversion'
import EventOpening from '@components/charts/membership/event/EventOpening'
import Page from '@components/Page/Page'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Col, Row, Space } from 'antd'

const AnalyticsTab = () => {
  return (
    <Page>
      <Col span={24}>
        <Row gutter={[32, 32]}>
          <Col sm={12} xs={24}>
            <Space orientation="vertical" className="w-full" size={10}>
              <PageTitle
                level={5}
                title={'Booking conversion'}
                style={{ margin: 0 }}
              />
              <BookingConversion />
            </Space>
          </Col>
          <Col sm={12} xs={24}>
            <Space orientation="vertical" className="w-full" size={10}>
              <PageTitle
                level={5}
                title={'Event openings'}
                style={{ margin: 0 }}
              />
              <EventOpening />
            </Space>
          </Col>
        </Row>
      </Col>
    </Page>
  )
}

export default AnalyticsTab
